import { useMemo } from "react"
import { useGetBuildingsQuery } from "../../../services/bClientApi"
import { BuildingEntryType } from "../../../Types/buildingTypes"
import QuickSelectModal, { QuickSelectOption } from "../QuickSelectModal/QuickSelectModal"

export function SelectBuildingModal(props: {
    active: boolean,
    onClose: () => void,
    onSelect: (buildingData: BuildingEntryType | BuildingEntryType[]) => void,
    message?: string
    title?: string
    multiSelect?: boolean
    filterFn?: (building: BuildingEntryType) => boolean
}) {

    const {
        active,
        onClose,
        onSelect,
        message = "Please select a building",
        title = "Choose Building",
        multiSelect = false,
        filterFn,
    } = props

    const {
        data: buildingsData,
        isLoading,
        isFetching,
    } = useGetBuildingsQuery({
        buildingsQuery: {},
        pagination: {
            page: 1,
            limit: 100
        }
    })

    const buildingsList: BuildingEntryType[] = useMemo(() => buildingsData?.docs || [], [buildingsData?.docs])

    const buildingsById = useMemo(() => {
        const map: Record<string, BuildingEntryType> = {}
        buildingsList.forEach((building) => {
            if (building._id) map[building._id] = building
        })
        return map
    }, [buildingsList])

    const options: QuickSelectOption[] = useMemo(() => {
        return buildingsList
            .filter((building) => {
                if (filterFn && !filterFn(building)) return false
                return true
            })
            .map((building) => ({
                id: building._id || '',
                label: building.title,
            }))
    }, [buildingsList, filterFn])

    const handleSelect = (selected: string | string[]) => {
        if (multiSelect && Array.isArray(selected)) {
            const buildingDataList = selected
                .map(id => buildingsById[id])
                .filter(b => b && b._id)
            if (buildingDataList.length > 0) {
                onSelect(buildingDataList)
            }
        } else if (typeof selected === 'string') {
            const buildingData = buildingsById[selected]
            if (buildingData && buildingData._id) {
                onSelect(buildingData)
            }
        }
        onClose()
    }

    return (
        <QuickSelectModal
            active={active}
            onClose={onClose}
            onSelect={handleSelect}
            options={options}
            title={title}
            message={message}
            multiSelect={multiSelect}
            isLoading={isLoading || isFetching}
            filterPlaceholder="Filter Buildings"
        />
    )
}
